import { Injectable } from '@angular/core';
import { IToast, Toast } from '@app/models';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private id = 0;

  addMessage$: Subject<Toast> = new Subject<Toast>();
  removedMessage$: Subject<number> = new Subject<number>();
  clearedMessages$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  success(message: string, title: string = '', duration: number = 5000, position: string = 'bottom-right') {
    const toast: IToast = {
      title,
      message,
      duration,
      position,
      class: 'success',
      icon: 'check_circle',
    };
    return this.create(toast);
  }

  warning(message: string, title: string = '', duration: number = 5000, position: string = 'bottom-right') {
    const toast: IToast = {
      title,
      message,
      duration,
      position,
      class: 'warning',
      icon: 'warning',
    };
    return this.create(toast);
  }

  error(message: string, title: string = '', duration: number = 5000, position: string = 'bottom-right') {
    const toast: IToast = {
      title,
      message,
      duration,
      position,
      class: 'error',
      icon: 'error',
    };
    return this.create(toast);
  }

  info(message: string, title: string = '', duration: number = 5000, position: string = 'bottom-right') {
    const toast: IToast = {
      title,
      message,
      duration,
      position,
      class: 'info',
      icon: 'info',
    };
    return this.create(toast);
  }

  remove(id: number) {
    this.removedMessage$.next(id);
  }

  clear() {
    this.clearedMessages$.next(true);
  }

  private create(toast: IToast): Toast {
    const model: Toast = new Toast(toast);
    model.id = this.generateId();
    this.addMessage$.next(model);
    return model;
  }

  private generateId(): number {
    this.id++;
    return this.id;
  }
}
